export const GWG_PROCESS_INDUSTRIES = [814, 821, 826, 832, 834, 840, 841];
